var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x33__x2C__XD_x2C__Adobe",
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.124,
    height: 108.87,
    viewBox: "0 0 110.124 108.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M0,0H110.124V108.87H0Z",
    transform: "translate(0 0)",
    fill: "#ff26be"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 102.423,
    height: 102.423,
    transform: "translate(3.85 3.224)",
    fill: "#2e001f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(19.983 28.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M134.243,137.4H125.47l-9.417,19.7-9.544-19.7H97.472l12.79,25.575L97.016,189.158h8.93l9.586-20.069,9.7,20.069H134.9l-13.653-26.495Zm24.252,0v13.162h-2.528c-8.627,0-19.056,5.563-19.056,19.773,0,10.985,5.566,19.242,17.421,19.242,8.729,0,12.841-3.02,12.841-3.02V137.4Zm-.009,44.615a9.235,9.235,0,0,1-3.357.439c-2.358,0-9.59-1.039-9.59-12.508s8.312-12.387,10.309-12.387a4.256,4.256,0,0,1,2.638.56v23.9Z",
    transform: "translate(-97.016 -137.396)",
    fill: "#ffd9f2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXd);
export default __webpack_public_path__ + "static/media/xd.9796919ec2584b1447c3125037004db4.svg";
export { ForwardRef as ReactComponent };